import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Popover from '@mui/material/Popover';
import React, { useEffect } from 'react';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import { selectFilterPaperStyle, titleFilterStyle, validationFilterButton, filterIconChipStyle, selectFilterMenuStyle, } from '../Filter.style';
import { multiMenuItemStyle } from './Multi.style';
import { Chip } from '../../Chip';
export const Multi = ({ filters, onSendFilters, title, label, dataQa, labelActionButton, hasValidation = false, paginationData, filtersMulti, setFiltersMulti, }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleOpen = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    const handleChange = (value) => {
        const newFilters = [...filtersMulti];
        if (newFilters.find((f) => f === value)) {
            const index = newFilters.indexOf(value);
            newFilters.splice(index, 1);
            sendData(newFilters);
        }
        else {
            if ([...newFilters, value].length === filters.length) {
                sendData([]);
            }
            else {
                sendData([...newFilters, value]);
            }
        }
    };
    const sendData = (value) => {
        setFiltersMulti(value);
        if (!hasValidation) {
            onSendFilters(value);
        }
        if (value.length === 0 && !hasValidation) {
            setAnchorEl(null);
        }
    };
    const handleSendFilters = () => {
        onSendFilters(filtersMulti);
        setAnchorEl(null);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleClickAway = (e) => {
        var _a;
        if (e.target.localName === 'div' && ((_a = e.target) === null || _a === void 0 ? void 0 : _a.className.indexOf('MuiBackdrop-root')) > -1 && !hasValidation) {
            setAnchorEl(null);
        }
    };
    const handleDelete = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setFiltersMulti([]);
        onSendFilters([]);
    };
    useEffect(() => {
        if ((paginationData === null || paginationData === void 0 ? void 0 : paginationData.changePageOnFiltering) && (paginationData === null || paginationData === void 0 ? void 0 : paginationData.setPage)) {
            paginationData.setPage(0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filtersMulti]);
    return (React.createElement(ClickAwayListener, { onClickAway: handleClickAway, disableReactTree: true },
        React.createElement(Box, { "data-qa": dataQa },
            React.createElement(Chip, { "data-qa": `${dataQa}-chip`, label: React.createElement(ChipLabel, { label: label, filtersMulti: filtersMulti, filters: filters }), onClick: handleOpen, variant: "outlined", selected: filtersMulti.length > 0, leftIcon: filtersMulti.length > 0 ? (React.createElement(CancelIcon, { onClick: handleDelete, "data-qa": `${dataQa}-iconCancel` })) : (React.createElement(AddCircleIcon, { "data-qa": `${dataQa}-iconAdd`, sx: filterIconChipStyle })), rightIcon: filtersMulti.length > 0 ? (open ? (React.createElement(ExpandLessOutlinedIcon, null)) : (React.createElement(ExpandMoreOutlinedIcon, { sx: { '&:hover': { cursor: 'default' } } }))) : undefined }),
            open ? (React.createElement(Popover, { "data-qa": `${dataQa}-select`, sx: selectFilterMenuStyle, id: "popoverFilterDates", open: open, onClose: handleClose, anchorEl: anchorEl, PaperProps: {
                    sx: Object.assign(Object.assign({}, selectFilterPaperStyle), { width: '248px' }),
                } },
                React.createElement(Box, { sx: titleFilterStyle },
                    React.createElement("h3", null, title)),
                filters.map((filter) => (React.createElement(MenuItem, { key: filter.value, value: filter.value, sx: multiMenuItemStyle, onClick: () => handleChange(filter.value) },
                    React.createElement(Checkbox, { "data-qa": `${dataQa}-checkbox`, checked: filtersMulti.indexOf(filter.value) > -1 }),
                    React.createElement(ListItemText, { primary: React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: '8px' } },
                            filter.iconTitle,
                            filter.title), sx: { pl: '8px' } })))),
                hasValidation && (React.createElement(Button, { "data-qa": `${dataQa}-validate`, color: "secondary", variant: "contained", onClick: handleSendFilters, fullWidth: true, sx: validationFilterButton }, labelActionButton)))) : null)));
};
const ChipLabel = ({ label, filtersMulti, filters, }) => {
    let filtersTitleListSliced = undefined;
    if (Array.isArray(filtersMulti) && filtersMulti.length > 0) {
        const filtersTitleList = filtersMulti.map((filter) => {
            const currentFilter = filters.find((f) => f.value === filter);
            return {
                title: (currentFilter === null || currentFilter === void 0 ? void 0 : currentFilter.title) || '',
                icon: currentFilter === null || currentFilter === void 0 ? void 0 : currentFilter.iconTitle,
            };
        });
        if (filtersTitleList.length > 3) {
            filtersTitleListSliced = [...filtersTitleList].slice(0, 3);
        }
        return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: '4px' } },
            label,
            React.createElement(Box, null, "|"),
            (filtersTitleListSliced ? filtersTitleListSliced : filtersTitleList).map((filter, index) => {
                return (React.createElement(Box, { key: index, sx: { display: 'flex', alignItems: 'center', gap: '4px' } },
                    filter.icon && React.createElement(Box, null, filter.icon),
                    React.createElement(Box, null,
                        filter.title,
                        index + 1 < (filtersTitleListSliced || filtersTitleList).length && ',')));
            }),
            filtersTitleList.length > 3 && React.createElement(Box, { sx: { ml: '-4px' } },
                ", +",
                filtersTitleList.length - 3)));
    }
    return React.createElement(Box, null, label);
};
